import { gql } from "@apollo/client";
import { User } from "../../api/schema";

export const UserQuery = gql`
  query User($userId: ID!) {
    user(id: $userId) {
      username
      id
      displayname
      email
      created_at
      updated_at
    }
  }
`;

export const UpdateProfileMutation = gql`
  mutation Mutation($values: UpdateUserInput!) {
    updateUser(values: $values) {
      id
    }
  }
`;

export const DeleteUserMutation = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;

export const CreateUserMutation = gql`
  mutation Mutation($values: CreateUserVariables!) {
    createUser(values: $values) {
      id
    }
  }
`;

export interface IUserQuery {
  user: User | null;
}

export interface IDeleteUserMutation {
  deleteUser: boolean;
}

export interface RegisterResponse {
  user: User;
}
